var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useLazyQuery } from '@apollo/client/react';
import { findFreePlanId } from 'app/domains/companies';
import { getPlansQuery } from './query';
export function useGetFreePlanID() {
    const [queryPlans] = useLazyQuery(getPlansQuery);
    const getFreePlanID = (marketCode) => __awaiter(this, void 0, void 0, function* () {
        var _a;
        const plans = yield queryPlans({
            variables: {
                marketCode,
            },
        });
        const planId = findFreePlanId((_a = plans.data) === null || _a === void 0 ? void 0 : _a.plans);
        if (!planId) {
            throw Error(`No plan_id found on ${marketCode}`);
        }
        return planId;
    });
    return { getFreePlanID };
}
